import {css} from 'styled-components'

export default css`
    .rbc-event {
        border: none;
        box-sizing: border-box;
        box-shadow: none;
        padding: var(--event-padding);
        background-color: var(--event-bg);
        border-radius: var(--event-border-radius);
        color: var(--event-color);
        cursor: pointer;
        width: 100%;
        text-align: left;
        margin: 0;

        .rbc-slot-selecting & {
            cursor: inherit;
            pointer-events: none;
        }

        &.rbc-selected {
            background-color: var(--event-bg);
        }

        &:focus {
            outline: 5px auto var(--event-outline);
        }
    }

    .rbc-event-label {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 80%;
    }

    .rbc-event-overlaps {
        box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, .5);
    }

    .rbc-event-continues-prior {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .rbc-event-continues-after {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }


    .rbc-event-continues-earlier {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    .rbc-event-continues-later {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

`
